import { Grid } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { H4 } from "../../../../components/NormalFonts";
import styles from "./styleModule";

const Slogan: React.FC = () => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <div
      className={`${styles.titleContainer} ${screens.md ? "" : styles.mobile}`}
    >
      <H4
        weight="heavy"
        className={`${styles.bannerTitle} ${screens.md ? "" : styles.mobile}`}
      >
        <Trans
          i18nKey={
            screens.lg
              ? [
                  `home.banner.title.${process.env.REACT_APP_PROD_NAME_DEV}`,
                  "home.banner.title",
                ]
              : [
                  `home.banner.title.short.${process.env.REACT_APP_PROD_NAME_DEV}`,
                  "home.banner.title.short",
                ]
          }
        />
      </H4>
    </div>
  );
};

export default Slogan;
